import { modalErrorStore } from '@/store'
import { modalErrorParameterInterface } from '@/store/ModalErrorStore'

export class ModalErrorService {
  public open(params?: modalErrorParameterInterface) {
    modalErrorStore.open(params)
  }

  public close() {
    modalErrorStore.close()
  }
}
